// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__K-nr9","col":"styles_col__2IGLh"};